import { combineReducers, configureStore } from "@reduxjs/toolkit";
import {
  persistReducer,
  persistStore,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storageSession from "redux-persist/lib/storage/session";
import loginReducer from "@client.pages/Login/reducer";
import dashboardReducer from "@client.pages/Dashboard/reducer";
import reportsReducer from "@client.pages/Reports/reducer";
import settingsReducer from "@client.pages/Settings/reducer";
import chartsReducer from "@client.components/Charts/reducer";
import topChartFiltersReducer from "@client.components/TopChartFilters/reducer";
import { getDateFrom, getDateTo } from "@client.components/Charts/utils";
import DateTypes from "@client.enums/dateTypes";

const rootReducer = combineReducers({
  login: loginReducer,
  dashboard: dashboardReducer,
  charts: chartsReducer,
  chartFilters: topChartFiltersReducer,
  reports: reportsReducer,
  settings: settingsReducer,
});

const persistConfig = {
  key: "root",
  storage: storageSession,
  whitelist: ["chartFilters"],
  stateReconciler: (inboundState, originalState) => {
    const chartFilters = {
      ...originalState.chartFilters,
      ...inboundState.chartFilters,
    };

    let typeValue = Number(chartFilters.filter.dateType);
    if (
      isNaN(typeValue) &&
      (chartFilters.filter.dateFrom === null ||
        chartFilters.filter.dateTo === null)
    ) {
      typeValue = Number(DateTypes.Last30Days);
      chartFilters.filter.dateType = DateTypes.Last30Days;
    }
    if (!isNaN(typeValue)) {
      chartFilters.filter.dateFrom = getDateFrom(Number(typeValue));
      chartFilters.filter.dateTo = getDateTo(Number(typeValue));
    }

    // TODO: remove email from the redux filter.
    if (chartFilters.filter.email) {
      chartFilters.filter.email = null;
    }
    return {
      ...originalState,
      chartFilters,
    };
  },
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const getStore = (initialState = null) => {
  const optionalSettings = {};
  if (initialState) {
    optionalSettings.preloadedState = initialState;
  }
  const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        },
      }),
    ...optionalSettings,
  });

  const persistor = persistStore(store);

  return { store, persistor };
};
